export default __webpack_public_path__ + "static/media/delete-icon.cc00f38b.svg";